import React from 'react'
import { FormattedDate } from 'react-intl'
import { Modal, Chip } from '@arnsbogroup/react-voicearchive'
import UsageStatusChip from 'components/UsageStatusChip'
import messages from './messages'
import { useIntl, FormattedMessage } from 'react-intl'

const UsageChainModal = ({ show, onClose, chain }) => {
  if (!chain || chain.length === 0) {
    return null
  }

  const { formatMessage } = useIntl()

  return (
    <Modal
      show={show}
      onClose={onClose}
      title={`${formatMessage(messages.title)}:`}
      dialogPanelClasses="max-w-screen-lg"
    >
      <div className="space-y-3">
        {chain.map((task, index) => {
          const isExtension = !!task.usage_parenttask_uid
          const airingStart = task.airing_time_start
            ? new Date(task.airing_time_start * 1000)
            : null
          const mediaText = task?.medias && task.medias.length > 0
            ? task.medias.map(m => `${m.name} (${m.spot_count})`).join(', ')
            : formatMessage(messages.notSet)
          const territoryMarketText = task?.territoryMarkets && task.territoryMarkets.length > 0
            ? task.territoryMarkets.map(tm => tm.name).join(', ')
            : formatMessage(messages.notSet)
          const airingTimeText = task?.usage && task?.usage[0]
            ? task?.usage[0]
            : formatMessage(messages.notSet)

          return (
            <div
              key={task.uid}
              className={`p-4 border rounded-lg ${
                isExtension ? 'bg-blue-50 border-blue-200' : 'bg-gray-50 border-gray-200'
              }`}
            >
              <div className="flex items-start justify-between">
                <div className="flex-1">
                  <div className="flex items-center gap-2 mb-2">
                    <span className="text-sm font-semibold text-gray-700">
                      {index === 0 ? formatMessage(messages.baseUsage) : `${formatMessage(messages.extension)} ${index}`}
                    </span>
                  </div>

                  <div className="space-y-1 text-sm">
                    <div className="text-gray-600">
                      <span className="font-medium"><FormattedMessage {...messages.airingTime} />:</span> {airingTimeText}
                    </div>
                    <div className="text-gray-600">
                      <span className="font-medium"><FormattedMessage {...messages.started} />:</span>{' '}
                      {airingStart ? (
                        <FormattedDate value={airingStart} />
                      ) : (
                        <FormattedMessage {...messages.notSet} />
                      )}
                    </div>
                    <div className="text-gray-600">
                      <span className="font-medium"><FormattedMessage {...messages.media} />:</span> {mediaText}
                    </div>
                    <div className="text-gray-600">
                      <span className="font-medium"><FormattedMessage {...messages.territoryMarket} />:</span> {territoryMarketText}
                    </div>
                  </div>
                </div>

                <div className="ml-4">
                  <UsageStatusChip task={task} forceIndividualStatus={true} />
                </div>
              </div>
            </div>
          )
        })}
      </div>
    </Modal>
  )
}

export default UsageChainModal
